module.exports = __webpack_public_path__ + "img/ai-input-text.4d34e004.svg";